import React from 'react';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import { SOCIAL_MEDIAS } from '../../models/constants/global.constant';
const useStyles = makeStyles(() => ({
    socials: {
        '& $svg': {
            margin: '8px auto',
            display: 'block'
        }
    }
}));
export const SocialMedia = () => {
    const classes = useStyles();
    return (React.createElement(Box, { component: 'div', sx: {
            display: 'flex',
            marginTop: '10px',
            flexDirection: 'row',
            justifyContent: { xs: 'center', lg: 'start' }
        }, className: classes.socials }, SOCIAL_MEDIAS.map((item, index) => (React.createElement(Box, { component: 'div', sx: {
            width: '32px',
            height: '32px',
            bgcolor: '#333333',
            borderRadius: '100%',
            color: '#fff',
            marginRight: '10px'
        }, key: index },
        React.createElement(Box, { component: 'a', href: item.url, target: '_blank', rel: 'noreferrer noopener', sx: {
                fontSize: '16px',
                color: '#fff',
                '&:hover': { color: '#fff', opacity: 0.8 }
            } },
            React.createElement(item.Icon, null)))))));
};
//# sourceMappingURL=Socialmedia.js.map